import { defineStore } from 'pinia';
import { computed } from 'vue';
import { store } from '/@/store';
import { apis } from '/@/apis';

interface PermissionState {
  permCodeList: string[] | number[];
}

export const usePermissionsStore = defineStore({
  id: 'permissions',
  state: (): PermissionState => ({
    permCodeList: [],
  }),
  getters: {
    getPermCodeList(): string[] | number[] {
      return this.permCodeList;
    },
  },
  actions: {
    setPermCodeList(codeList: string[]) {
      this.permCodeList = codeList;
    },

    async changePermissionCode() {
      const { getPermissions } = apis.users;
      const codeList = await getPermissions();
      this.setPermCodeList(codeList);
    },

    hasPermission(code: string) {
      return computed(() => !!this.permCodeList.find((v) => v === code));
    },
  },
});

// Need to be used outside the setup
// 需要在设置之外使用
export function usePermissionsStoreWithOut() {
  return usePermissionsStore(store);
}
